import React from "react";

/**
 * @typedef Service
 * @property {string} color
 * @property {string} name
 *
 * @param {object} props
 * @param {Service} [props.service]
 * @param {boolean} [props.disabled]
 */
export default function ServiceTag({ service, disabled }) {
  return (
    <div
      style={{
        borderRadius: "4px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--mui-palette-divider)",
        padding: "calc(var(--mui-spacing) / 4) calc(var(--mui-spacing) / 2)",
        display: "flex",
        alignItems: "center",
        maxWidth: "100%",
        width: "fit-content",
        fontSize: "0.9rem",
        backgroundColor: "var(--mui-palette-background-default)",
      }}
    >
      <div
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          backgroundColor: service?.color,
          minWidth: "1em",
          width: "1em",
          aspectRatio: "1 / 1",
          marginRight: "calc(var(--mui-spacing) / 2)",
        }}
      />
      <span
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          maxWidth: "100%",
          color: disabled
            ? "var(--mui-palette-action-disabled)"
            : "var(--mui-palette-_components-heading-color)",
        }}
      >
        {service?.name}
      </span>
    </div>
  );
}
